export enum UserAssessmentStatus {
    Start = "1",
    Pause = "2",
    Restart = "3",
    Complete = "4",
    Abort = "5",
    TimeOut = "6",
    Started = "7"
}